const root = "_35sr17pqigm";
const wrapper = "_35swa34eye";
const container = "_35scf5mlc4";
const header = "_35sh15vu3ui";
const heading = "_35sh1bt7kpj";

export { container, header, heading, root, wrapper };
import "./organism.input-container.style.linaria.module.css";
//# sourceMappingURL=organism.input-container.style.js.map
